// extracted by mini-css-extract-plugin
export default {"legalDiv":"legalPageStyle_legalDiv__vWSv4","termsBtn":"legalPageStyle_termsBtn__qWLDL","list":"legalPageStyle_list__tkZ8r"};